import ContentItemDetails from "./ContentItemDetails";
export default ContentItemDetails;
